export const CSV_BINDING_TYPE__VARIABLE = 'variable';
export const CSV_BINDING_TYPE__PATH = 'path';
export const CSV_BINDING_TYPES = [
  CSV_BINDING_TYPE__VARIABLE,
  CSV_BINDING_TYPE__PATH,
];
